import { makeStyles } from "@material-ui/core/styles";
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from "react-admin";
import React from "react";

const useEditToolbarStyles = makeStyles({
    defaultToolbar: {
        flex: 1,
        display: 'flex',
        justifyContent: 'space-between',
    },
});

interface Props extends ToolbarProps {
    showDelete: boolean;
}

export const EditToolbar = (props: Props) => {
    const classes = useEditToolbarStyles();
    const {
        alwaysEnableSaveButton,
        basePath,
        handleSubmitWithRedirect,
        handleSubmit,
        invalid,
        mutationMode,
        pristine,
        record,
        redirect,
        resource,
        saving,
        showDelete,
        submitOnEnter,
        undoable,
        validating,
    } = props;

    const disabled = alwaysEnableSaveButton === true || pristine || validating;

    return (
        <Toolbar {...props} >
            <div className={classes.defaultToolbar}>
                <SaveButton
                    handleSubmitWithRedirect={
                        handleSubmitWithRedirect || handleSubmit
                    }
                    disabled={disabled}
                    invalid={invalid}
                    redirect={redirect}
                    saving={saving || validating}
                    submitOnEnter={submitOnEnter}
                />
                {record && typeof record.id !== 'undefined' && showDelete && (
                    <DeleteButton
                        basePath={basePath}
                        record={record}
                        resource={resource}
                        undoable={undoable}
                        mutationMode={mutationMode}
                    />
                )}
            </div>
        </Toolbar>
    );
}